import React, {useState} from "react";
import { useLocation } from "react-router-dom";
import { Row, Table, Collapse, DatePicker } from "antd";
import Title from "antd/es/typography/Title";
import { Container } from "react-bootstrap";
import Navbar from "../../components/Navbar/Navbar";
import { UseGetRequest, UsePostRequest } from "../../utils/api/ApiRequests";
import { capitalizeEachWord, formatDate, formatShortDate } from "../../utils/Common";
import moment from "moment";
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

const {Panel} = Collapse;
const {RangePicker} = DatePicker;

export default function EmployeeHistoryReport () {
    const location = useLocation();
    const employeeData = location.state;
    const [leaveHistoryData, setLeaveHistoryData] = useState([]);
    // const [wfaHistoryData, setWfaHistoryData] = useState([]);
    const [absentHistoryData, setAbsentHistoryData] = useState([]);
    const [presentHistoryData, setPresentHistoryData] = useState([]);
    const [regOtHistoryData, setRegOtHistoryData] = useState([]);
    const [restDayOtHistoryData, setRestDayOtHistoryData] = useState([]);
    const [lateHistoryData, setLateHistoryData] = useState([]);
    const [undertimeHistoryData, setUndertimeHistoryData] = useState([]);
    const [commLetters, setCommLetters] = useState([]);
    const [tableData, setTableData] = useState({
        regular_ot: [],
        restday_ot: [],
        late: [],
        undertime: [],
    })
    const dateToday = moment().format('YYYY-MM-DD');
    
    const [filterConfig, setFilterConfig] = useState({
        date_from: employeeData.date_from || dateToday,
        date_to: employeeData.date_to || dateToday,
        employee_id: employeeData.id,
    });

    const handleDateFilter = (e) => {
        if (e) {
            setFilterConfig((prev) => ({...prev,
                date_from: e[0].format('YYYY-MM-DD'),
                date_to: e[1].format('YYYY-MM-DD'),
            }));
        }
      }

    const tableColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (date) => (
                <div>{date}</div>
            )
        },
      ];

      const commTable = [
        {
          title: "Code",
          dataIndex: "code",
          key: "code",
        },
        {
          title: "Date Posted",
          dataIndex: "letter_date",
          key: "letter_date",
          render: (letter_date, record) => (
            <div>{moment(letter_date).format("MMM DD, YYYY")}</div>
          ),
        },
        {
          title: "Subject",
          dataIndex: "subject",
          key: "subject",
        },
        {
          title: "Letter From",
          dataIndex: "letter_from",
          key: "letter_from",
        },
        {
          title: "Letter To",
          dataIndex: "details",
          key: "details",
          render: (details, record) => (
            <ul
              className="pointer-cursor custom-list"
            >
              {details.map((value, index) => (
                <li key={index}>{value.letter_to}</li>
              ))}
            </ul>
          ),
        },
        {
          title: "Prepared By",
          dataIndex: "added_by_name",
          key: "added_by_name",
          render: (data, record) => (
            <div>
              <Row>{data}</Row>
              <Row>{moment(record.added_on).format("MMM DD, YYYY hh:mm A")}</Row>
            </div>
          ),
        },
        // {
        //   title: "Approved By",
        //   dataIndex: "approved_by_name",
        //   key: "approved_by_name",
        //   render: (data, record) => (
        //     <div>
        //       <Row>{data}</Row>
        //       <Row>{record.status==="approved"&&moment(record.updated_on).format("MMM DD, YYYY hh:mm A")}</Row>
        //     </div>
        //   ),
        // },
        // {
        //   title: "Status",
        //   dataIndex: "status",
        //   key: "status",
        //   render: (data) => <div>{capitalizeEachWord(data)}</div>
        // },
      ];

    function getMergeData (object) {
        const temp_array = object.map((data) => {
            let info = {}
            info.x = moment(data[0], 'MMM D, YYYY').toDate()
            info.y = Number(data[1])
            return info;
        })
        return temp_array;
    }

    const regOtDataset = getMergeData(regOtHistoryData);
    const restDayOtDataset = getMergeData(restDayOtHistoryData);
    const lateDataset = getMergeData(lateHistoryData);
    const undertimeDataset = getMergeData(undertimeHistoryData);      

    // Get the unique set of dates from both datasets
    const allDatesSet = new Set([...regOtDataset.map(data => data.x), ...restDayOtDataset.map(data => data.x), ...lateDataset.map(data => data.x), ...undertimeDataset.map(data => data.x)]);
    const allDates = Array.from(allDatesSet).sort((a, b) => a - b);

    // Create aligned datasets with null values for missing dates
    const regOtLineData = allDates.map(date => {
        const data = regOtDataset.find(item => item.x === date);
        return data ? { x: formatShortDate(date), y: data.y } : { x: formatShortDate(date), y: 0 };
    });

    const restDayOtLineData = allDates.map(date => {
        const data = restDayOtDataset.find(item => item.x === date);
        return data ? { x: formatShortDate(date), y: data.y } : { x: formatShortDate(date), y: 0 };
    });

    const lateLineData = allDates.map(date => {
        const data = lateDataset.find(item => item.x === date);
        return data ? { x: formatShortDate(date), y: data.y } : { x: formatShortDate(date), y: 0 };
    });

    const undertimeLineData = allDates.map(date => {
        const data = undertimeDataset.find(item => item.x === date);
        return data ? { x: formatShortDate(date), y: data.y } : { x: formatShortDate(date), y: 0 };
    });

    const chartOptions = {
        scales: {
        y: {
            beginAtZero: true,
            title: {
            display: true,
            text: 'No. of Minutes', // Replace with your desired label text
            },
        },
        },
    };

    const lineData = {
        datasets: [
            {
                label: 'Regular OT',
                data: regOtLineData,
                borderColor: 'red',
                fill: false,
                lineTension: 0.1,
            },
            {
                label: 'Rest Day OT',
                data: restDayOtLineData,
                borderColor: 'orange',
                fill: false,
                lineTension: 0.1
            },
            {
                label: 'Late',
                data: lateLineData,
                borderColor: 'green',
                fill: false,
                lineTension: 0.1
            },
            {
                label: 'Undertime',
                data: undertimeLineData,
                borderColor: 'blue',
                fill: false,
                lineTension: 0.1
            },
        ],
    };

    async function fetchCommLetters() {
        setCommLetters([]);
          const response = await UseGetRequest("letters/get", {employee_id: employeeData.id, status: "approved"});
          if (response.data) {
            const res = response.data.data?.letters?.map((data) => {
              const info = data;
              info.recipients = data.details.map((rec) => {
                let recInfo = {};
                recInfo.type = rec.type;
                recInfo.letter_to = rec.letter_to_id;
                return recInfo;
              });
              return info;
            });
            setCommLetters(res);
          }
      }

    React.useEffect(() => {
        async function fetchHistoryData () {
            setLeaveHistoryData([]);
            // setWfaHistoryData([]);
            setAbsentHistoryData([]);
            setPresentHistoryData([]);
            setRegOtHistoryData([]);
            setRestDayOtHistoryData([]);
            setLateHistoryData([]);
            setUndertimeHistoryData([]);
            setTableData({
                regular_ot: [],
                restday_ot: [],
                late: [],
                undertime: [],
            })


            const response = await UsePostRequest("timesheets/performance_evaluation_details", filterConfig);
            if (response.data) {
                const res = response.data[0];
          
                if (res.leave_dates) {
                    const tempArray = res.leave_dates.map((item) => {
                        let info = {}
                        info.date = formatDate(item.date);
                        return info;
                    })
                    setLeaveHistoryData(tempArray);
                }

                if (res.absent_dates) {
                    const tempArray = res.absent_dates.map((item) => {
                        let info = {}
                        info.date = formatDate(item);
                        return info;
                    })
                    setAbsentHistoryData(tempArray);
                }

                if (res.present_dates) {
                    const tempArray = res.present_dates.map((item) => {
                        let info = {}
                        info.date = formatDate(item);
                        return info;
                    })
                    setPresentHistoryData(tempArray);
                }

                if (res.regular_ot_dates) {
                    let tempTableData = []
                    const tempArray = res.regular_ot_dates.map((item) => {
                        let temp = []
                        tempTableData.push({date: `${formatDate(item.regular_ot_date)} (${item.regular_ot_hr} hrs)`});
                        temp.push(formatShortDate(item.regular_ot_date), item.regular_ot_hr);
                        return temp;
                    })
                    setTableData((prev) => ({...prev, regular_ot: tempTableData}))
                    setRegOtHistoryData(tempArray);
                }

                if (res.restday_ot_dates) {
                    let tempTableData = []
                    const tempArray = res.restday_ot_dates.map((item) => {
                        let temp = []
                        tempTableData.push({date: `${formatDate(item.restday_ot_date)} (${item.restday_ot_hr} hrs)`});
                        temp.push(formatShortDate(item.restday_ot_date), item.restday_ot_hr);
                        return temp;
                    })
                    setTableData((prev) => ({...prev, restday_ot: tempTableData}))
                    setRestDayOtHistoryData(tempArray);
                }

                if (res.late_dates) {
                    let tempTableData = []
                    const tempArray = res.late_dates.map((item) => {
                        let temp = []
                        tempTableData.push({date: `${formatDate(item.late_date)} (${item.late_hr} hrs)`});
                        temp.push(formatShortDate(item.late_date), item.late_hr);
                        return temp;
                    })
                    setTableData((prev) => ({...prev, late: tempTableData}))
                    setLateHistoryData(tempArray);
                }

                if (res.undertime_dates) {
                    let tempTableData = []
                    const tempArray = res.undertime_dates.map((item) => {
                        let temp = []
                        tempTableData.push({date: `${formatDate(item.undertime_date)} (${item.undertime_hr} hrs)`});
                        temp.push(formatShortDate(item.undertime_date), item.undertime_hr);
                        return temp;
                    })
                    setTableData((prev) => ({...prev, undertime: tempTableData}))
                    setUndertimeHistoryData(tempArray);
                }
            }
        }

        fetchCommLetters();

        fetchHistoryData();
    }, [filterConfig])

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        BarElement,
        ArcElement,
        // Title,
        Tooltip,
        Legend
    );

    return (
        <Navbar formPageTitle="Employee History Report" isForm>
            <Container>
                <Row>
                    <Title level={4}>Employee: {capitalizeEachWord(employeeData.fullname)}</Title>
                </Row>
                <Row className="d-flex justify-content-end mt-3 mb-5">
                    <RangePicker style={{width: 500}} onChange={handleDateFilter} placeholder={[filterConfig.date_from, filterConfig.date_to]}/>
                </Row>
                <Line data={lineData} options={chartOptions} className='line-chart'/>
                <Collapse accordion className="my-5 custom-collapse">
                    <Panel header="Leave" key="leave">
                        <Table dataSource={leaveHistoryData} columns={tableColumns}/>
                    </Panel>
                    
                    <Panel header="Absent" key="absent">
                        <Table dataSource={absentHistoryData} columns={tableColumns}/>
                    </Panel>
                    <Panel header="Present" key="present">
                        <Table dataSource={presentHistoryData} columns={tableColumns}/>
                    </Panel>
                    <Panel header="Regular OT" key="regular_ot">
                        <Table dataSource={tableData.regular_ot} columns={tableColumns}/>
                    </Panel>
                    <Panel header="Restday OT" key="restday_ot">
                        <Table dataSource={tableData.restday_ot} columns={tableColumns}/>
                    </Panel>
                    <Panel header="Late" key="late">
                        <Table dataSource={tableData.late} columns={tableColumns}/>
                    </Panel>
                    <Panel header="Undertime" key="undertime">
                        <Table dataSource={tableData.undertime} columns={tableColumns}/>
                    </Panel>
                    <Panel header="Communication Letter" key="communicationletter">
                        <Table dataSource={commLetters} columns={commTable}/>
                    </Panel>
                </Collapse>
            </Container>
        </Navbar>
    )
}